/* eslint-disable */
import React from 'react';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import { appConstants} from "../../_constants";
import CardBody from "components/Card/CardBody.jsx";
import Button from "components/CustomButtons/Button.jsx";
import { primaryColor } from "assets/jss/material-dashboard-react.jsx";
import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import Icon from "@material-ui/icons/NetworkCheck";

const styles = {
    space:{
      padding:'5px',
      textAlign:"left",
    },
    space2:{
        padding:'8px',
        textAlign:"center",
    },
    title:{
      fontWeight:'300',
        textAlign:"center"
    },
    root: {
        flexGrow: 1,
        width:'100%',
        height:'100%',
        background:"url('img/airport2.jpg')",
        backgroundPosition:'center',
        backgroundSize:'cover',
        backgroundRepeat:'no-repeat',
    },
    overlay: {
        flexGrow: 1,
        width:'100%',
        height:'100vh',
        background:"rgba(0,0,0,.6)"
    },
    paper: {
        textAlign: 'center',
    },
    center:{
        alignItems:'center',
        justifyContent:'center',
        width:'100%',
        height:'100%'
    },
    checked: {
        color: primaryColor + "!important"
    },
    checkedIcon: {
        width: "20px",
        height: "20px",
        border: "1px solid rgba(0, 0, 0, .54)",
        borderRadius: "3px"
    },
    uncheckedIcon: {
        width: "0px",
        height: "0px",
        padding: "10px",
        border: "1px solid rgba(0, 0, 0, .54)",
        borderRadius: "3px"
    },
    radio: {
        color: primaryColor + "!important"
    },
    radioChecked: {
        width: "20px",
        height: "20px",
        border: "1px solid " + primaryColor,
        borderRadius: "50%"
    },
    radioUnchecked: {
        width: "0px",
        height: "0px",
        padding: "10px",
        border: "1px solid rgba(0, 0, 0, .54)",
        borderRadius: "50%"
    }
};

class NotFound extends React.Component {
    render() {
        return (
            <div style={styles.root}>
                <div style={styles.overlay}>
                    <Grid container style={styles.center}>
                        <Grid item lg={6} sm={12}>
                            <Card>
                                <CardHeader color="success" stats icon>
                                    <CardIcon color="success">
                                        <Icon />
                                    </CardIcon>
                                </CardHeader>
                                <CardBody style={{textAlign: 'center', paddingTop: 0}}>
                                    <h1 style={{textAlign: 'center', margin: 0, fontSize: '65px'}}>
                                        4
                                        <span style={{fontSize: '80px', color: appConstants.DANGER_COLOR}}>0</span>
                                        4
                                    </h1>
                                    <h4 style={{margin: '0 0 15px'}}>
                                        Oops! We can't seem to find the page you're looking for.
                                    </h4>
                                    <Link to={'/landing'}>
                                        <Button
                                            type="button"
                                            color="primary"
                                        >
                                             Go to Homepage
                                         </Button>
                                    </Link>
                                </CardBody>
                            </Card>
                        </Grid>
                    </Grid>
                    <Grid container style={{background: "rgba(0,0,0,.9)", color: "white"}}>
                        <Grid item lg={12}>
                            <p style={{textAlign: "center", color: "white"}}>© {new Date().getFullYear()} FAAN PSC
                                Automation Portal</p>
                        </Grid>
                    </Grid>
                </div>
            </div>

        )
    }
}

export default withStyles(dashboardStyle)(NotFound);



// WEBPACK FOOTER //
// ./src/layouts/NotFound/Index.jsx